import ClassNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import {
  default as VARIABLES
} from './../../../themes/styles/bases/variables'
import {
  ContainerBaseWrapper
} from './styled'

export class ContainerBase extends React.PureComponent {
  render() {
    const {
      // Option
      children,
      className,
      // Default
      direction,
      wrap,
      justify,
      align,
      width,
      widthUnit,
      height,
      calcHeight,
      calcMinHeight,
      heightUnit,
      padding,
      paddingHorizontal,
      paddingVertical,
      paddingTop,
      paddingRight,
      paddingBottom,
      paddingLeft,
      paddingUnit,
      bgColor,
      bgImage,
      bgRepeat,
      bgSize,
      bgPositionX,
      bgPositionY,
      bgPosition,
      // Responsive > Mobile
      widthMobile,
      heightMobile,
      calcHeightMobile,
      calcMinHeightMobile,
      widthMobileUnit,
      heightMobileUnit,
      paddingMobile,
      paddingHorizontalMobile,
      paddingVerticalMobile,
      paddingTopMobile,
      paddingRightMobile,
      paddingBottomMobile,
      paddingLeftMobile,
      // Responsive > Phablet
      widthPhablet,
      heightPhablet,
      calcHeightPhablet,
      calcMinHeightPhablet,
      widthPhabletUnit,
      heightPhabletUnit,
      paddingPhablet,
      paddingHorizontalPhablet,
      paddingVerticalPhablet,
      paddingTopPhablet,
      paddingRightPhablet,
      paddingBottomPhablet,
      paddingLeftPhablet,
      // Responsive > Tablet
      widthTablet,
      heightTablet,
      widthTabletUnit,
      heightTabletUnit,
      calcHeightTablet,
      calcMinHeightTablet,
      paddingTablet,
      paddingHorizontalTablet,
      paddingVerticalTablet,
      paddingTopTablet,
      paddingRightTablet,
      paddingBottomTablet,
      paddingLeftTablet,
      // Breakpoint
      breakpointPaddingMobile,
      breakpointPaddingPhabletMin,
      breakpointPaddingPhabletMax,
      breakpointPaddingTabletMin,
      breakpointPaddingTabletMax
    } = this.props

    return (
      <ContainerBaseWrapper
        className={ClassNames(
          'container-base',
          // Option
          className
        )}
        theme={{
          // Default
          direction,
          wrap,
          justify,
          align,
          width,
          widthUnit,
          height,
          calcHeight,
          calcMinHeight,
          heightUnit,
          padding,
          paddingHorizontal,
          paddingVertical,
          paddingTop,
          paddingRight,
          paddingBottom,
          paddingLeft,
          paddingUnit,
          bgColor,
          bgImage,
          bgRepeat,
          bgSize,
          bgPositionX,
          bgPositionY,
          bgPosition,
          // Responsive > Mobile
          widthMobile,
          heightMobile,
          calcHeightMobile,
          calcMinHeightMobile,
          widthMobileUnit,
          heightMobileUnit,
          paddingMobile,
          paddingHorizontalMobile,
          paddingVerticalMobile,
          paddingTopMobile,
          paddingRightMobile,
          paddingBottomMobile,
          paddingLeftMobile,
          // Responsive > Phablet
          widthPhablet,
          heightPhablet,
          calcHeightPhablet,
          calcMinHeightPhablet,
          widthPhabletUnit,
          heightPhabletUnit,
          paddingPhablet,
          paddingHorizontalPhablet,
          paddingVerticalPhablet,
          paddingTopPhablet,
          paddingRightPhablet,
          paddingBottomPhablet,
          paddingLeftPhablet,
          // Responsive > Tablet
          widthTablet,
          heightTablet,
          widthTabletUnit,
          heightTabletUnit,
          calcHeightTablet,
          calcMinHeightTablet,
          paddingTablet,
          paddingHorizontalTablet,
          paddingVerticalTablet,
          paddingTopTablet,
          paddingRightTablet,
          paddingBottomTablet,
          paddingLeftTablet,
          // Breakpoint
          breakpointPaddingMobile,
          breakpointPaddingPhabletMin,
          breakpointPaddingPhabletMax,
          breakpointPaddingTabletMin,
          breakpointPaddingTabletMax
        }}
      >
        {children}
      </ContainerBaseWrapper>
    )
  }

  static defaultProps = {
    direction: 'column',
    wrap: 'wrap',
    align: 'flex-start',
    widthUnit: 'px',
    heightUnit: 'px',
    paddingUnit: 'px',
    // Responsive
    widthMobileUnit: 'px',
    widthPhabletUnit: 'px',
    widthTabletUnit: 'px',
    heightMobileUnit: 'px',
    heightPhabletUnit: 'px',
    heightTabletUnit: 'px',
    // Breakpoint
    breakpointPaddingMobile: VARIABLES.BREAKPOINTS.BP_413,
    breakpointPaddingPhabletMin: VARIABLES.BREAKPOINTS.BP_414,
    breakpointPaddingPhabletMax: VARIABLES.BREAKPOINTS.BP_767,
    breakpointPaddingTabletMin: VARIABLES.BREAKPOINTS.BP_768,
    breakpointPaddingTabletMax: VARIABLES.BREAKPOINTS.BP_1279,
  }

  static propTypes = { // TYPE > node, string, number, bool, array, object, symbol, func

    className: PropTypes.string,
    direction: PropTypes.string,
    wrap: PropTypes.string,
    justify: PropTypes.string,
    align: PropTypes.string,
    width: PropTypes.number,
    widthUnit: PropTypes.string,
    height: PropTypes.number,
    calcHeight: PropTypes.string,
    calcMinHeight: PropTypes.string,
    heightUnit: PropTypes.string,
    padding: PropTypes.number,
    paddingHorizontal: PropTypes.number,
    paddingVertical: PropTypes.number,
    paddingTop: PropTypes.number,
    paddingRight: PropTypes.number,
    paddingBottom: PropTypes.number,
    paddingLeft: PropTypes.number,
    paddingUnit: PropTypes.string,
    bgColor: PropTypes.string,
    bgImage: PropTypes.string,
    bgRepeat: PropTypes.string,
    bgSize: PropTypes.string,
    bgPositionX: PropTypes.string,
    bgPositionY: PropTypes.string,
    bgPosition: PropTypes.string,
    // Responsive > Mobile
    widthMobile: PropTypes.number,
    heightMobile: PropTypes.number,
    calcHeightMobile: PropTypes.string,
    calcMinHeightMobile: PropTypes.string,
    widthMobileUnit: PropTypes.string,
    heightMobileUnit: PropTypes.string,
    paddingMobile: PropTypes.number,
    paddingHorizontalMobile: PropTypes.number,
    paddingVerticalMobile: PropTypes.number,
    paddingTopMobile: PropTypes.number,
    paddingRightMobile: PropTypes.number,
    paddingBottomMobile: PropTypes.number,
    paddingLeftMobile: PropTypes.number,
    // Responsive > Phablet
    widthPhablet: PropTypes.number,
    heightPhablet: PropTypes.number,
    calcHeightPhablet: PropTypes.string,
    calcMinHeightPhablet: PropTypes.string,
    widthPhabletUnit: PropTypes.string,
    heightPhabletUnit: PropTypes.string,
    paddingPhablet: PropTypes.number,
    paddingHorizontalPhablet: PropTypes.number,
    paddingVerticalPhablet: PropTypes.number,
    paddingTopPhablet: PropTypes.number,
    paddingRightPhablet: PropTypes.number,
    paddingBottomPhablet: PropTypes.number,
    paddingLeftPhablet: PropTypes.number,
    // Responsive > Tablet
    widthTablet: PropTypes.number,
    heightTablet: PropTypes.number,
    widthTabletUnit: PropTypes.string,
    heightTabletUnit: PropTypes.string,
    calcHeightTablet: PropTypes.string,
    calcMinHeightTablet: PropTypes.string,
    paddingTablet: PropTypes.number,
    paddingHorizontalTablet: PropTypes.number,
    paddingVerticalTablet: PropTypes.number,
    paddingTopTablet: PropTypes.number,
    paddingRightTablet: PropTypes.number,
    paddingBottomTablet: PropTypes.number,
    paddingLeftTablet: PropTypes.number,
    // Breakpoint
    breakpointPaddingMobile: PropTypes.string,
    breakpointPaddingPhabletMin: PropTypes.string,
    breakpointPaddingPhabletMax: PropTypes.string,
    breakpointPaddingTabletMin: PropTypes.string,
    breakpointPaddingTabletMax: PropTypes.string,

    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.string
    ])
  }
}
